import { atom } from "jotai";

export interface ChatDebugInfo {
  messageCount: number;
  originalMessageCount: number;
  estimatedTokens: number;
  wasTruncated: boolean;
  lastTruncationTime: string | null;
}

export const chatDebugAtom = atom<ChatDebugInfo>({
  messageCount: 0,
  originalMessageCount: 0,
  estimatedTokens: 0,
  wasTruncated: false,
  lastTruncationTime: null,
});

chatDebugAtom.debugLabel = "chatDebugAtom";
